import { UserDto } from './../models/user';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseService } from './base-service.service';
import { ApiResponse } from '../models/api-response.model';
import { catchError, Observable } from 'rxjs';
import { UserInfo } from '../models/user-info';


@Injectable({
  providedIn: 'root',
})
export class UsersService extends BaseService {
  constructor(private http: HttpClient) {
    super();
  }

  getRequestSubmitterInfo(RequestId: string) : Observable<ApiResponse<UserDto>> {
    return this.http
    .get<ApiResponse<UserDto>>(`/api/user/GetRequestSubmitterInfo?id=${RequestId}`)
      .pipe(catchError(this.handleError));
  }
  getUserInfo()
  {
    return this.http
    .get<ApiResponse<UserInfo>>(`/api/user/GetUserInfo`)
      .pipe(catchError(this.handleError));
  }
  updatePreferredNotificationLanguage(langKey:string)
  {
    return this.http
    .get<ApiResponse<boolean>>(`/api/user/UpdatePreferredNotificationLanguage/${langKey}`)
      .pipe(catchError(this.handleError));
  }


  UpdateProfile(post: any): Observable<any> 
  {
    return this.http.post<any>('/api/user/UpdateProfile', post);
  }

  
}
